import { Box, Grid, Typography } from "@mui/material";
import { IDeliveryTripItemList } from "types/Sales/billing-note";
import { numberFormatter } from "utils/Formatter/Global";
import { flattenDeliveryTrips } from "utils/Formatter/Sales/BillingNote";

type Props = {
  controlledFields: IDeliveryTripItemList[];
};

const TotalPreVatAmount = ({ controlledFields }: Props) => {
  const totalPreVatAmount = flattenDeliveryTrips(controlledFields).reduce(
    (prev, acc) => prev + acc.income_item_pre_vat_amount,
    0,
  );
  return (
    <Box
      sx={{
        my: 1,
        display: "flex",
        alignItems: "center",
        gap: 3,
        height: "2rem",
      }}
      bgcolor={"secondary.main"}
      width="fit-content"
      marginLeft="auto"
      justifyItems="flex-end"
      borderRadius={1}
    >
      <>
        <Typography
          color={"primary.main"}
          textAlign={"right"}
          flex={2}
          minWidth={50}
          fontWeight={600}
        >
          รวม
        </Typography>
        <Typography
          color={"primary.main"}
          variant="subtitle1"
          sx={{ minWidth: 150, textAlign: "right", mr: 2, flex: 1 }}
          fontWeight={600}
        >
          {numberFormatter(totalPreVatAmount)}
        </Typography>
      </>
      <Typography
        color={"primary.main"}
        sx={{ ml: 2.5, mr: 4 }}
        fontWeight={600}
      >
        บาท
      </Typography>
    </Box>
  );
};

export default TotalPreVatAmount;
